const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'jam',
  tiles: { dummy: 0 },
  uidata: { rects: [ vec4(8/64,8/64,40/64,40/64) ] },
  layers: undefined,
  FRAME_DUMMY: 0
};
spritesheetRegister(module.exports);
